import { defaultOptions, setCookie } from "../../Helpers";
import { ActionDimensions } from "../dimensions/ActionDimensions";
import Cookies from 'js-cookie';


const updateScreenHistory = (screenName : string)=>{    
    const prevScreenParsed = Cookies.get('prevScreen') ?? '';
    const prevScreenArr = prevScreenParsed.split(',')
    let prevScreen = '';
    if(prevScreenArr.length === 1)
      prevScreen = prevScreenArr[0];
    else
      prevScreen = prevScreenArr[1];
    if(prevScreen && prevScreen !== screenName)
        ActionDimensions.getInstance().prevScreen = prevScreen;
    ActionDimensions.getInstance().currScreen = screenName;
    setCookie('prevScreen', screenName, {...defaultOptions, expires: 10})
}

export {updateScreenHistory}